// extracted by mini-css-extract-plugin
module.exports = {"rhsLinkWidget":"lv7Hb","rhsLinkWidgetTitle":"HFxuX","linkWrap":"dedgJ"};